// The valid country codes for the given citizenship.  If no codes exist for the citizenship, then all country codes are valid.
const citizenOptionsIncludeCountryFilter: { [code: string]: string[] } = {
  1: ['0001'], // Australia
  2: ['S501'], // New Zealand
  // Federated States of Micronesia, Fiji, Nauru, Palau, Papua New Guinea, Solomon Islands
  // Timor-Leste, Tonga, Tuvalu, Vanuatu
  P: ['0086', 'S506', 'S507', '0088', 'S502', 'S509', '0848', 'S510', '0093', 'S511'] 
};

// The country codes that are excluded for the given citizenship.  If no codes exist for the citizenship, then no country codes are excluded.
const citizenOptionsExcludeCountryFilter: { [code: string]: string[] } = {
  3: ['0001', 'S501'], // Exclude Australia and New Zealand for Permanent Resident of Australia
  4: ['0001', 'S501'], // Exclude Australia and New Zealand for International Student applying to study in Australia
  5: ['0001', 'S501'], // Exclude Australia and New Zealand for International Student applying to a campus outside Australia or Fully Online
  8: ['0001', 'S501']  // Exclude Australia and New Zealand for Australian Permanent Humanitarian Visa Holder
};

/**
 * Returns true if the country code is included in the country list for the given citizenship.
 * 
 * @param countryCode a four letter country code 
 * @param citizenship a single letter citizenship code
 * @returns true if the country code is included in the country list for the given citizenship.  Returns false otherwise.
 */
export function isCountryCodeIncludedForCitizenship(countryCode: string, citizenship: string): boolean {
  return (!citizenOptionsIncludeCountryFilter[citizenship] || citizenOptionsIncludeCountryFilter[citizenship].includes(countryCode)) &&
         (!citizenOptionsExcludeCountryFilter[citizenship] || !citizenOptionsExcludeCountryFilter[citizenship].includes(countryCode));
}